import { getQueryParam } from '../../routing/getQueryParam';
export const ACQ0141_EXPERIMENT_ID = 'acq-0141';
export const getHasAcq0141TrackingParam = () => {
  const externalExperimentParameter = getQueryParam('external-experiment-parameter');
  return [`${ACQ0141_EXPERIMENT_ID}-group-variant`, `${ACQ0141_EXPERIMENT_ID}-group-control`].includes(externalExperimentParameter);
};